import React, { useState } from 'react'

import { WithPopover } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import classNames from 'classnames'
import { useVdCurrencyFilter } from '../../../ng-compat/hooks'
import { CustomPopover } from './CustomPopover'
import { useDisplayEcomCustomSurchargesRow } from './useDisplayEcomCustomSurchargesRow'

export const SaleEcomCustomCharges = () => {
  const vdCurrencyFilter = useVdCurrencyFilter()
  const [isOpen, setIsOpen] = useState(false)
  const showPopover = () => setIsOpen(true)
  const closePopover = () => setIsOpen(false)
  const t = useT()
  const {
    popoverSurchargesRows,
    surcharges,
  } = useDisplayEcomCustomSurchargesRow()

  const noSurcharge =
    !popoverSurchargesRows || popoverSurchargesRows?.length === 0

  if (noSurcharge) return null

  const hasOneSurcharge =
    popoverSurchargesRows && popoverSurchargesRows.length === 1
  const description = hasOneSurcharge
    ? popoverSurchargesRows[0].name
    : `${t('{numberOfCharges} included', {
        _context: 'Ecom custom surcharge row in the sale summary',
        numberOfCharges: popoverSurchargesRows.length,
      })}`

  const rowName = hasOneSurcharge
    ? `${t('Surcharge', {
        _context: 'Ecom custom surcharge row header with one charge',
      })}`
    : `${t('Surcharges', {
        _context: 'Ecom custom surcharge row header with multiple charges',
      })}`

  return (
    <>
      <div className="vd-input--text-align-left sale-total-line-item--fullline">
        <WithPopover direction="left" alignment="start">
          <RowName
            name={rowName}
            description={description}
            amount={vdCurrencyFilter(surcharges?.totalIncl)}
            onClick={showPopover}
          />
          {isOpen && (
            <CustomPopover
              title={rowName}
              rows={popoverSurchargesRows}
              onClose={closePopover}
            />
          )}
        </WithPopover>
      </div>
    </>
  )
}

type RowNameProps = {
  name: string
  description: string
  amount: string
  onClick?: () => void
}
const RowName = (props: RowNameProps) => {
  const { onClick, name, description, amount } = props
  const cssClass = classNames('vd-text-label', 'sale-total-line-item--nowrap', {
    'vd-link': !!onClick,
  })

  return (
    <div className="vd-flex vd-flex--justify-between vd-flex--align-center">
      <div className="vd-flex vd-flex--align-center">
        <span className={cssClass} onClick={onClick}>
          {name}
        </span>
        <span className="sale-total-line-item--sub">{description}</span>
      </div>
      <div className="vd-flex--align-end sale-total-line-item--right">
        <div className="vd-text-label">{amount}</div>
      </div>
    </div>
  )
}
